var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App"},_vm._l((_vm.apps),function(item,index){return _c('collapse',{key:index,staticClass:"AppItem",attrs:{"title":item.title}},[_c('list',{attrs:{"list":item.urls}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }